import React from 'react'
import { node, bool } from 'prop-types'
import styled, { css } from 'styled-components'
import { stripUnit } from 'polished'

import { media, mediaDown } from 'styles/media'
import * as spacing from 'styles/spacing'

const Container = styled.div`
  position: static;

  ${props =>
    props.padded &&
    css`
      margin-bottom: ${spacing.large};

      ${media.medium`
        margin-bottom: ${spacing.xLarge};
      `};

      ${media.large`
        margin-bottom: ${spacing.xxLarge};
      `};
    `}
`

const Inner = styled.div`
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: ${spacing.small};
  margin-bottom: -${spacing.small};

  ${mediaDown.medium`
    margin-left: -${spacing.large};
    margin-right: -${spacing.large};
    padding-left: ${spacing.large};
    padding-right: ${spacing.large};
  `};
`

const Scroll = styled.div`
  display: flex;
  margin: -${spacing.tiny};

  ${media.medium`
    margin: -${stripUnit(spacing.tiny) * 1.5 + 'px'};
  `};
`

const Item = styled.div`
  padding: ${spacing.tiny};

  ${media.medium`
    padding: ${stripUnit(spacing.tiny) * 1.5 + 'px'};
  `};
`

const Tabs = ({ children, padded }) => (
  <Container padded={padded}>
    <Inner>
      <Scroll>
        {React.Children.map(children, (child, i) => {
          if (child) {
            return <Item key={i}>{child}</Item>
          }
        })}
      </Scroll>
    </Inner>
  </Container>
)

Tabs.propTypes = {
  children: node.isRequired,
  padded: bool
}

export default Tabs
